export default "__VITE_ASSET__Bf6Gm$TA__"